// 旧插件和自定义组件的安装顺序可能不同，运行时选取真正的旧渲染器，不能回指自身。
export function resolveLegacyMap (components = {}) {
  for (const name of ['avue-echart-legacy-map', 'avue-echart-map']) {
    const renderer = components[name]
    const options = renderer && (renderer.options || renderer)
    if (options && options.deviceLocationMap !== true) return renderer
  }
  return null
}

// ECharts4的highlight动作只更新series；geo需要恢复区域图形原生emphasis，而非伪造选中态。
export function highlightGeoRegion (chart, name, active) {
  if (!name || !chart || !chart.getModel || !chart.getViewOfComponentModel) return
  const model = chart.getModel().getComponent('geo'), view = model && chart.getViewOfComponentModel(model)
  if (!view || !view.group) return
  view.group.traverse(element => {
    const event = element.eventData
    if (event && event.componentType === 'geo' && event.name === name) {
      const target = element.parent || element
      if (target.trigger) target.trigger(active ? 'emphasis' : 'normal')
    }
  })
}
